import { type ChangeEvent, useRef } from "react"

import type { SX, ThemeKeys } from "../../theme"
import styles from "./TextArea.module.css"

export interface TextAreaProps {
  autoComplete?: string
  id?: string
  name?: string
  onChange?: (value: string) => void
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
  value?: string
  paddingLeft?: ThemeKeys<"space">
  paddingRight?: ThemeKeys<"space">
  sx?: SX
  onBlur?: () => void
}

export function TextArea(props: TextAreaProps) {
  const {
    onChange,
    value,
    sx,
    paddingLeft = 8,
    paddingRight = 8,
    placeholder,
    ...otherProps
  } = props

  const autoGrowHiddenRef = useRef<HTMLDivElement>(null)

  function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
    if (value === undefined && autoGrowHiddenRef.current !== null)
      autoGrowHiddenRef.current.textContent = wrap(event.target.value)

    onChange?.(event.target.value)
  }

  const paddingInlineStyle = {
    paddingLeft,
    paddingRight,
  }

  return (
    <div className={styles.root} style={sx}>
      <textarea
        {...otherProps}
        className={styles.textarea}
        style={paddingInlineStyle}
        onChange={handleChange}
        placeholder={placeholder}
        value={value}
      />
      <div
        className={styles.autoGrow}
        style={paddingInlineStyle}
        ref={autoGrowHiddenRef}
      >
        {
          // This is a hack to make the textarea grow automatically
          // If there is no value, we use the placeholder to ensure
          // the height is correct based on the wrapped text
          // Since the placeholder can also be multiline
          wrap(value || placeholder)
        }
      </div>
    </div>
  )
}

function wrap(str: string | undefined): string {
  return (str ?? "").concat(" ")
}
